module.exports = __webpack_public_path__ + "static/img/img-about-4.c94db31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-4.png
// module id = Xxkk
// module chunks = 0